import React from 'react'
import { useScrollAnimation } from '../hooks/useScrollAnimation'

const Process = () => {
  const { ref, isVisible } = useScrollAnimation()

  const candidateSteps = [
    {
      icon: 'fas fa-file-lines',
      title: 'Share Your Profile',
      description: 'Quickly create your profile and highlight your skills, experience, and career goals. Let us understand what matters most to you.'
    },
    {
      icon: 'fas fa-magnifying-glass-chart',
      title: 'Smart Matching',
      description: 'Our recruiters connect you with employers and roles that suit not only your skills but your values and culture fit.'
    },
    {
      icon: 'fas fa-trophy',
      title: 'Interview & Placement',
      description: 'We organise interviews, guide you through the process, and support you as you accept your offer and start your new role.'
    }
  ]

  const employerSteps = [
    {
      icon: 'fas fa-briefcase',
      title: 'Submit Your Role',
      description: 'Share your vacancy and requirements with us. Include skills, experience, and the cultural traits that make your team thrive.'
    },
    {
      icon: 'fas fa-users',
      title: 'Tailored Candidate Search',
      description: 'We carefully screen our network to present candidates who are not only qualified but the right cultural fit for your organisation.'
    },
    {
      icon: 'fas fa-handshake',
      title: 'Interview & Hire',
      description: 'We coordinate interviews, facilitate connections, and support a smooth hiring process from offer to onboarding.'
    }
  ]

  return (
    <section id="process" className="process section section-alt" ref={ref}>
      <div className="container">
        <div className="section-header">
          <div className={`section-tag ${isVisible ? 'animate-fadeInUp' : ''}`}>
            How It Works
          </div>
          <h2 className={`${isVisible ? 'animate-fadeInUp' : ''}`}>
            Your Path to the <span className="gradient-text">Right Match</span>
          </h2>
        </div>

        <div className="process-dual-timeline">
          {/* Candidates Track */}
          <div className="timeline-track track-candidates">
            <h3 className={`timeline-track-title ${isVisible ? 'animate-fadeInUp' : ''}`}>
              For <span className="gradient-text">Candidates</span>
            </h3>
            <div className="timeline-steps">
              <div className={`timeline-line ${isVisible ? 'draw' : ''}`}></div>
              {candidateSteps.map((step, index) => (
                <div
                  key={index}
                  className={`timeline-step ${isVisible ? 'animate-fadeInUp' : ''}`}
                  style={{ animationDelay: `${200 + index * 200}ms` }}
                >
                  <div className={`timeline-dot ${isVisible ? 'pop' : ''}`} style={{ animationDelay: `${400 + index * 200}ms` }}>
                    {index + 1}
                  </div>
                  <div className="timeline-card">
                    <div className="card-header">
                      <div className="step-icon">
                        <i className={step.icon}></i>
                      </div>
                      <h4>{step.title}</h4>
                    </div>
                    <p>{step.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Employers Track */}
          <div className="timeline-track track-employers">
            <h3 className={`timeline-track-title ${isVisible ? 'animate-fadeInUp' : ''}`}>
              For <span className="gradient-text">Employers</span>
            </h3>
            <div className="timeline-steps">
              <div className={`timeline-line ${isVisible ? 'draw' : ''}`}></div>
              {employerSteps.map((step, index) => (
                <div
                  key={index}
                  className={`timeline-step ${isVisible ? 'animate-fadeInUp' : ''}`}
                  style={{ animationDelay: `${200 + index * 200}ms` }}
                >
                  <div className={`timeline-dot ${isVisible ? 'pop' : ''}`} style={{ animationDelay: `${400 + index * 200}ms` }}>
                    {index + 1}
                  </div>
                  <div className="timeline-card">
                    <div className="card-header">
                      <div className="step-icon">
                        <i className={step.icon}></i>
                      </div>
                      <h4>{step.title}</h4>
                    </div>
                    <p>{step.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Process
